angular.module('cn')

.component('networkNameEditor', {
  template: '<input focus-if class=".name-edit-input" type="text" ng-model="$ctrl.name" ' +
    'ng-change="$ctrl.callback({name: $ctrl.name})" ng-model-options="{updateOn: \'blur\'}" />',
  bindings: {
    name: '<',
    callback: '&'
  }
})

.component('cnCrud', {
  template: require('./cncrud.html'),
  controller: [
    'networksRepository',
    'networkRelationsRepository',
    'accountsRepository',
    '$routeParams',
    '$rootScope',
    '$uibModal',
    '$location',
    function(
      networksRepository,
      networkRelationsRepository,
      accountsRepository,
      $routeParams,
      $rootScope,
      $uibModal,
      $location
    ) {
      var $ctrl = this;

      // TODO reduce this method complexity
      var handleApiResponse = function(network) {
        if (network) {
          if (network.root) {
            var relationsPromise = networkRelationsRepository.getRelations(network.root);
            network.root.setRelations(relationsPromise);
            return relationsPromise.then(function() {
              $ctrl.network = network;
              return network;
            });
          } else {
            $ctrl.network = network;
            return network;
          }
        }
      };

      this.$onInit = function() {
        var networkId = $routeParams.id;
        networksRepository.get(networkId).then(handleApiResponse)
        .catch(function() {
          $location.path('/');
        });
      };

      this.saveNetwork = function(newName) {
        networksRepository.save($ctrl.network, {
          // name: $ctrl.networkName
          name: newName
        })
        .then(handleApiResponse)
        .then(function() {
          $rootScope.$emit('onBackendSuccess', 'Network saved successfully');
        });
      };

      this.setRoot = function(data) {
        return networksRepository.save($ctrl.network, {
          root: data
        })
        .then(handleApiResponse)
        .then(function() {
          $rootScope.$emit('onBackendSuccess', 'Root successfully set for this network');
        });
      };

      this.addNewAccount = function(parent, data) {
        networksRepository.addAccountToNetwork(parent, data)
        .then(handleApiResponse)
        .then(function() {
          $rootScope.$emit('onBackendSuccess', 'Account successfully linked to this network');
        });
      };

      this.removeAccount = function(account) {
        $uibModal.open({
          animation: false,
          component: 'modalconfirm',
          resolve: {
            title: function() {
              return `Remove ${account.name}?`;
            },
            message: function() {
              return `${account.name} will be removed from this network. ` +
                `This will not delete the acccount from the Back Office`;
            },
            okCopy: function() {
              return 'Remove account';
            },
            cancelCopy: function() {
              return 'Cancel removal';
            }
          }
        }).result.then(function(doDelete) {
          if (doDelete) {
            networksRepository.removeAccountFromNetwork(account)
            .then(handleApiResponse)
            .then(function() {
              $rootScope.$emit('onBackendSuccess', 'Account successfully unlinked from the network');
            });
          }
        });
      };

      this.moveAccount = function(account, oldParent, newParent) {
        networksRepository.setAccountParent(account, newParent)
        .then(handleApiResponse)
        .then(function() {
          $rootScope.$emit('onBackendSuccess', 'Account successfully moved');
        });
      };

      this.showError = function(message) {
        $rootScope.$emit('onBackendError', message);
      };

      this.extraAction = function(actionName) {
        switch (actionName) {
          case 'linkRetailers':
            $uibModal.open({
              animation: false,
              component: 'retailers',
              resolve: {
                network: function() {
                  return $ctrl.network;
                },
                account: function() {
                  return $ctrl.network.root;
                }
              }
            });
          break;
        }
      };

      $ctrl.openNetworkEditor = function() {
        $uibModal.open({
          animation: false,
          component: 'createnetwork',
          resolve: {
            network: function() {
              return $ctrl.network;
            }
          }
        }).result.then(handleApiResponse);
      };

      $ctrl.askForDelete =  function() {
        $uibModal.open({
          animation: false,
          component: 'deletenetwork',
          resolve: {
            network: function() {
              return $ctrl.network;
            }
          }
        });
      };

    }
  ]
});



// WEBPACK FOOTER //
// ./src/cn/cncrud.js